export enum PaymentMethodAccountType {
  fiat = 'FIAT',
  crypto = 'CRYPTO',
}
